import React, {useEffect, useState} from 'react'
import API from '../../services/api'
import { getGenerateUrl } from '../../utils/constants';
import BirdViewData from './BirdViewData';

function DashBoardStats() {
    const [loader, setLoader] = useState(false)
  const [newsPaperData, setNewsPaperData] = useState([]);
  const [stats, setStats] = useState([])
  const [selected, setSelected] = useState({})

    const fetchStats = async() =>{
        setLoader(true)
        try {
            let res = await API({
                url:'/sales_dashboard/dashboardStats',
                method:'POST',
                responseType:'json',
                data:{}
            })
            if(res.code === 200){
                setStats(res.data)
            }
        } catch (error) {
            console.error(error)
        }
        finally{
            setLoader(false)
        }
    }
    const fetchNewsPapers = async() =>{
        try {
          let res = await API({
            url: "/market/newspapers",
            method: "POST",
            responseType:'json',
            data:{}
          })
          if(res.code === 200){
            setNewsPaperData([...res.data])
          }
        } catch (error) {
          console.error(error)
        }
      }
    const getLogo = (brand) =>{
        const brandLookup = newsPaperData.filter(np => np.name === brand)
        return brandLookup?.[0]?.logo
      }
    useEffect(() => {
        fetchNewsPapers()
      fetchStats()
    }, [])
    
    const getBrandBBV = async(brand, record_date) => {
      try {
        let startDate = new Date(record_date)
        let endDate = new Date(record_date)
        endDate.setHours(23,59,59,59)
        let obj = {date :{startDate, endDate}, record_date, brand_id: brand.brand_id, sales_person_id: brand.sales_person_id}
        setSelected(obj)
      } catch (error) {
        console.error("Error @ getBrandBBV", error)
      }

    }
  return (
    <>
    <div className='d-flex gap-3 flex-wrap flex-col mt-2 dashboard_stats'>
    {! loader && stats?.length > 0 ? stats.map((record, index) => (
        <div  className ='d-flex flex-col  border rounded' key={index}>
          <div  className='d-flex gap-3  p-2 flex-wrap flex-col'>
            <div className='mobileCenter font-semibold text-xl'>{new Date(record.date).toDateString()}</div>
            <div className='d-flex gap-3  p-2 flex-wrap'>
            {record.records?.map((brand, index) => (
                <div className={'d-flex flex-col border rounded p-2 mobileCenter dashboard-brand' + (brand.brand_id === selected?.brand_id && record.date === selected.record_date ? ' active' : '')} key={index} onClick={() => {setSelected({});getBrandBBV(brand, record.date)}}>
                    <div className='flex gap-2 px-1 items-center'>
                        <img className='h-4' src={brand.url || getGenerateUrl(brand.brand_name)} alt='L'></img>
                        <h6 title={brand.brand_name} className='truncate'>{brand.brand_name}</h6>
                    </div>
                    <div className="d-flex gap-1">
                        {brand?.camp_targets?.map((item, idx) => (
                            <img key={idx} className="w-6" src={getLogo(item)} alt="logo" />
                        ))}
                        {brand?.w2n_spent !== "0.00" ? <img src={getLogo('Way2news')} alt="notexist" /> : null}
                    </div>
                </div>
            ))}
            </div>
          </div>
            {Object.keys(selected)?.length && record.date === selected.record_date ? <div className='border-top '>
            <BirdViewData brand={selected.brand_id} salesPerson_id={selected.sales_person_id} date={selected.date}  fetchW2n={true} fetchAllNews={true}/>
            </div> :null}
            
        </div>
    )) : <><svg data-v-5eed88b5="" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="bird-icon flip" strokeWidth="1"><path d="M16 7h.01"></path><path d="M3.4 18H12a8 8 0 0 0 8-8V7a4 4 0 0 0-7.28-2.3L2 20"></path><path d="m20 7 2 .5-2 .5"></path><path d="M10 18v3"></path><path d="M14 17.75V21"></path><path d="M7 18a6 6 0 0 0 3.84-10.61"></path></svg>
        <h2>No Data Found</h2></>}
</div>

    </>
  )
}

export default DashBoardStats